import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Table, Typography, Button, Tooltip, Popconfirm, Row, Col, Drawer, Form, Input, Checkbox, Card, Dropdown, Menu, message, Select, DatePicker, Spin, Modal, Space, Upload, Avatar, Tag, Switch } from 'antd';
import { useNavigate } from 'react-router-dom';
import { DownOutlined, EditOutlined, CopyOutlined, PushpinOutlined, SearchOutlined, CloseOutlined, DeleteOutlined, ImportOutlined, SettingOutlined, CaretDownOutlined, PhoneOutlined, FilterOutlined, ExportOutlined, PushpinFilled } from '@ant-design/icons';
import { BASE_URL, DateFormat } from '../Components/Constant';
import dayjs from 'dayjs';
import CreateRecordDrawer from './CreateRecordDrawer';
import CreateRecordModal from './CreateRecordModal';
import CreateListViewDrawer from '../Object/CreateListViewDrawer';
import ApiService from '../Components/apiService'; // Import ApiService class
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { generateBody, formatRecordData, fetchLookupData } from '../Components/Utility';
import ExportModal from '../ImportExport/ExportModal';
import ListViewTable from './ListViewTable';
import { useSelector } from "react-redux";
import isEqual from "lodash/isEqual";
import Cookies from 'js-cookie';
import { GridViewTable } from './GridViewTable';

dayjs.extend(customParseFormat);

const { Title } = Typography;
const { Option } = Select;


const ObjectSetupDetail = ({ gridViewEnabled }) => {

  const { id } = useParams();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [objectName, setObjectName] = useState(null);
  const [objectPluralName, setobjectPluralName] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [fieldsData, setFieldsData] = useState([]);
  const [fieldsDataDrawer, setFieldsDataDrawer] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [lookupName, setLookupName] = useState('');
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [listViews, setListViews] = useState([]);
  const [selectedView, setSelectedView] = useState('');
  const [selectedListView, setSelectedListView] = useState(null); // State to store the selected list view for editing
  const [isListViewDrawerVisible, setIsListViewDrawerVisible] = useState(false);
  const [objectForListView, setObjectForListView] = useState();
  const [ListViewInDrawer, SetListViewInDrawer] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0); // Total number of records
  const [isMetadataFetched, setIsMetadataFetched] = useState(false); // Track metadata fetching
  const [isExportModalVisible, setIsExportModalVisible] = useState(false);
  const [searchRecord, setSearchRecord] = useState('');
  const [showInput, setShowInput] = useState(false); // State to toggle input visibility
  const [allRecords, setAllRecords] = useState([]);
  const [pageSize, setPageSize] = useState(100);
  const [isCreateNewRecord, setIsCreateNewRecord] = useState(false);
  const [isListViewFromObjectPage, setIsListFromObjectPage] = useState(false);
  const [creationView, setCreationView] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const security = useSelector((state) => state.data.items[0]);
  const currUserId = Cookies.get('userId');
  const currUserName = Cookies.get('name');
  const [tableView, setTableView] = useState(gridViewEnabled ? 'gridView' : 'listView');
  const [activeCurrencies, setActiveCurrencies] = useState([]);


  useEffect(() => {
  let isMounted = true; // safety flag to avoid setting state after unmount

  const fetchAllData = async () => {
    setLoading(true);
    setError(null);

    try {
      // 1️⃣ Fetch Metadata
      const metaService = new ApiService(`${BASE_URL}/mt_objects/${id}`, { 'Content-Type': 'application/json' }, 'GET');
      const objectRes = await metaService.makeCall(navigate);
      if (!isMounted) return;

      setObjectForListView(objectRes);
      setObjectName(objectRes?.name);
      setobjectPluralName(objectRes?.pluralLabel);
      setCreationView(objectRes?.record_creation_view);

      // 2️⃣ Fetch Fields
      const fieldsService = new ApiService(`${BASE_URL}/mt_fields/object/${objectRes?.name}`, { 'Content-Type': 'application/json' }, 'GET');
      const fieldsRes = await fieldsService.makeCall(navigate);
      if (!isMounted) return;
      setFieldsDataDrawer(fieldsRes);

      // 3️⃣ Fetch List Views
      const listViewService = new ApiService(`${BASE_URL}/list-views/${objectRes?.name}`, { 'Content-Type': 'application/json' }, 'GET');
      const listViewRes = await listViewService.makeCall(navigate);
      if (!isMounted) return;

      const listViews = listViewRes.list_views || [];
      setListViews(listViews);

      // Pick the default view
      const defaultListView = listViews.find(lv => lv.is_default) || listViews[0];
      setSelectedView(defaultListView);
      setSelectedListView(defaultListView);

      // 4️⃣ Fetch Records
      if (defaultListView) {
        await fetchRecords(defaultListView, 1);
      }

      setIsMetadataFetched(true);
    } catch (err) {
      console.error('Error during initialization:', err);
      if (isMounted) setError('Failed to load data');
    } finally {
      if (isMounted) setLoading(false);
    }
  };

  fetchAllData();

  return () => {
    isMounted = false;
  };
}, [id]); // only re-run when id changes


  // useEffect(() => {
  //   setCurrentPage(1);
  //   if (objectName) {
  //     fetchListViews();
  //   }
  // }, [objectName, isMetadataFetched]);

  useEffect(() => {
    setRecords([]);
    setLoading(true);
    setCurrentPage(1); // Reset to the first page
    if (listViews?.length != 0) {
      const defaultlistview = listViews?.find(listview => listview.is_default === true);
      console.log('defaultlistview :: ', defaultlistview);
      setSelectedListView(defaultlistview); // Clear selected view
      setSelectedView(defaultlistview); // Reset selected view state
      if (defaultlistview) {
        fetchRecords(defaultlistview, 1); // Fetch records with updated metadata
      }
    }

  }, [objectName, isMetadataFetched]);

  const fetchRecords = async (selectedViewId, page = currentPage, size = pageSize) => {
    setLoading(true);

    console.log('Fetching records for view:', selectedViewId);

    const offsetValue = (page - 1) * size;
    const limit = size;
    let apiServiceForRecords;

    try {

      if (selectedViewId) {
        apiServiceForRecords = new ApiService(
          `${BASE_URL}/mt_list_views/${selectedViewId?._id}/records/${limit}/${offsetValue}`,
          { 'Content-Type': 'application/json' },
          'GET'
        );
        setSelectedListView(selectedViewId);

      }


      const recordsResponse = await apiServiceForRecords.makeCall();

      setRecords(recordsResponse?.records);
      setAllRecords(recordsResponse?.records);


      setTotalRecords(recordsResponse?.total);


      if (selectedViewId?._id) {
        // Get the field names from the recordsResponse
        const recordFieldNames = Object.keys(recordsResponse[0] || {}); // First record as an example
        const fieldOfListView = selectedViewId?.fields_to_display || recordFieldNames;


        // Filter fields from fieldsResponse based on whether their name exists in the recordFieldNames
        const matchingFields = fieldOfListView.map(fieldName => {
          // Determine the matching field in fieldsDataDrawer
          return fieldsDataDrawer.find(field => {
            // For non-lookup fields, match directly
            return field.name.toLowerCase() === fieldName.toLowerCase();
          });
        }).filter(Boolean); // Filter out undefined entries (if no match was found)

        if (selectedViewId?._id) {
          if (selectedViewId?.fields_to_display?.includes('created_at')) {
            matchingFields.push(
              {
                name: 'created_at',
                label: 'Created At',
                type: 'datetime',
                is_system: true,
              }
            );
          }
          if (selectedViewId?.fields_to_display?.includes('updated_at')) {
            matchingFields.push(
              {
                name: 'updated_at',
                label: 'Updated At',
                type: 'datetime',
                is_system: true,
              }
            );
          }

        }
        setFieldsData(matchingFields);
      }
      else {
        const extendedFields = [...fieldsDataDrawer];
        extendedFields.push(
          {
            name: 'created_at',
            label: 'Created At',
            type: 'datetime',
            is_system: true,
          },
          {
            name: 'updated_at',
            label: 'Updated At',
            type: 'datetime',
            is_system: true,
          }
        );
        setFieldsData(extendedFields);

      }
    }
    catch (err) {
      const errorMessage = err && typeof err === 'object'
        ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to fetch record due to an unknown error';
      console.log('error in fetching records', err);
      message.error(errorMessage);
      setRecords([]);
    }
    finally {
      setLoading(false);
    }
    setCurrentPage(page);
    setPageSize(size);
  }

  const fetchListViews = async () => {
    setLoading(true);
    const apiService = new ApiService(
      `${BASE_URL}/list-views/${objectName}`,
      { 'Content-Type': 'application/json' },
      'GET'
    );

    try {
      const response = await apiService.makeCall(navigate);
      const listViews = response.list_views || [];
      setListViews(listViews);

      // Try to restore previously selected list view (if stored)
      const previouslySelected =
        listViews.find(lv => lv._id === selectedListView?._id);

      // If not found, fall back to default list view
      const defaultListView = listViews.find(lv => lv.is_default === true);

      const finalSelection = previouslySelected?._id ? previouslySelected : defaultListView;

      setSelectedListView(finalSelection);
      setSelectedView(finalSelection);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        navigate("/AccessDenied");
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setLoading(false);
    }
  };



  const handleViewChange = (value) => {

    const matchedView = listViews.find(view => view._id === value);

    setSelectedListView(matchedView);

    setSelectedView(matchedView);

    setPageSize(100); // Reset page size to default for the new view
    setCurrentPage(1); // Reset to the first page
    fetchRecords(matchedView, 1, 100); // Fetch records for the selected view with default pagination


  };

  const handleCreateClick = async () => {
    if (security?.object_settings?.[objectName]?.object_setting.create === false) {
      message.error('You dont have permission to create ');
      return;
    }

    if(objectName==="Timesheet"){
      navigate(`/timesheet`);
      return;
    }

    setSelectedRecord(null); // Ensure no record is selected when creating a new record
    form.resetFields(); // Clear the form fields
    if (creationView === "Modal") {
      setModalVisible(true);
    }
    else {
      setDrawerVisible(true);
    }
    setIsCreateNewRecord(true);
    setTimeout(() => {
      const drawerContent = document.querySelector('.ant-drawer-body');
      if (drawerContent) {
        drawerContent.scrollTop = 0; // Reset scroll to the top
      }
    }, 200);

    try {
      //setLoading(true);

      // Create an instance of ApiService for fetching fields data
      const apiServiceForFields = new ApiService(
        `${BASE_URL}/mt_fields/object/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET' // Specify the method as 'GET'
      );

      // Fetch the fields data
      const response = await apiServiceForFields.makeCall();
      setFieldsDataDrawer(response);

    } catch (error) {
      console.error('Error fetching API response:', error);
    } finally {
      // setLoading(false); // Stop the spinner regardless of success or failure
    }
  };

  const handleEditClick = async (record) => {
    if (security?.object_settings?.[objectName]?.object_setting.edit === false) {
      message.error('You dont have permission to edit ');
      return;
    }
    // Fetch fields data first to check for date fields
    // if(objectName==="Batch"){
    //   navigate(`/EnhancedCreateRecord/${objectName}/${record?._id}`, { state: { record } });
    //   return;
    // }

    // if(objectName==="Order"){
    //   navigate(`/OrderScreen/${record?._id}`);
    //   return;
    // }

    if(objectName==="Timesheet"){
      navigate(`/timesheet`);
      return;
    }
    setIsCreateNewRecord(false);
    try {
      //setLoading(true); 

      const apiServiceforCurrentRecord = new ApiService(
        `${BASE_URL}/fetch_single_record/${objectName}/${record._id}`,
        { 'Content-Type': 'application/json' },
        'GET' // Specify the method as 'GET'
      );
      // Create an instance of ApiService for fetching fields data
      const apiServiceForFields = new ApiService(
        `${BASE_URL}/mt_fields/object/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET' // Specify the method as 'GET'
      );

      const recordResponse = await apiServiceforCurrentRecord.makeCall();
      const fieldsResponse = await apiServiceForFields.makeCall();
      setFieldsDataDrawer(fieldsResponse);

      // Format date fields in the record before setting them in the form
      const formattedRecord = await formatRecordData(recordResponse, fieldsResponse, BASE_URL);
      setSelectedRecord(formattedRecord);
      form.setFieldsValue(formattedRecord);
      if (creationView === "Modal") {
        setModalVisible(true);
      }
      else {
        setDrawerVisible(true);
      }

      setTimeout(() => {
        const drawerContent = document.querySelector('.ant-drawer-body');
        if (drawerContent) {
          drawerContent.scrollTop = 0; // Reset scroll to the top
        }
      }, 300);

      // Fetch lookup data
      fetchLookupData(recordResponse, fieldsResponse, BASE_URL, setLookupName, form);


    } catch (error) {
      console.error('Error fetching API response:', error);
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to update record due to an unknown error';
      message.error(errorMessage);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchCurrency();
  }, []);

  const handleCloneClick = async (record) => {
    if (security?.object_settings?.[objectName]?.object_setting.create === false) {
      message.error('You dont have permission to create ');
      return;
    }
    if(objectName==="Timesheet"){
      navigate(`/timesheet`);
      return;
    }
    try {
      // Fetch the original record data
      const apiServiceforCurrentRecord = new ApiService(
        `${BASE_URL}/fetch_single_record/${objectName}/${record._id}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );

      const recordResponse = await apiServiceforCurrentRecord.makeCall();
      setIsCreateNewRecord(true);


      // Fetch fields data
      const apiServiceForFields = new ApiService(
        `${BASE_URL}/mt_fields/object/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );

      const fieldsResponse = await apiServiceForFields.makeCall();
      setFieldsDataDrawer(fieldsResponse);

      // Clone and remove ID and set isClone to true
      const clonedRecord = { ...recordResponse, _id: undefined, isClone: true };

      // Format the cloned record data
      const formattedClonedRecord = await formatRecordData(clonedRecord, fieldsResponse, BASE_URL);
      setSelectedRecord(formattedClonedRecord);
      form.setFieldsValue(formattedClonedRecord);

      // Fetch and set lookup data
      fetchLookupData(clonedRecord, fieldsResponse, BASE_URL, setLookupName, form);

    } catch (error) {
      console.error('Error fetching API response:', error);
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to clone record due to an unknown error';
      message.error(errorMessage);
    } finally {
      // setLoading(false);
    }

    if (creationView === "Modal") {
      setModalVisible(true);
    }
    else {
      setDrawerVisible(true);
    } // Open the drawer after setting the values
  };

  const handleFinish = async (values, saveAndNew = false) => {
    const updatedValues = generateBody(fieldsDataDrawer, values, (selectedRecord?._id && !selectedRecord?.isClone) ? false : true);
    if (updatedValues === "error") {
      return;
    }
    const changedValues = {};
    if (creationView === 'Modal') {
      updatedValues.RecordType = values.RecordType;
    }

    if (selectedRecord?._id) {

      Object.keys(updatedValues).forEach((key) => {
        const newValue = updatedValues[key];
        const oldValue = selectedRecord[key];

        const isNewKey = !(key in selectedRecord);
        const isEmpty = newValue === "" || newValue === null || newValue === undefined;

        if (!isEqual(newValue, oldValue)) {
          if (!isNewKey || (isNewKey && !isEmpty)) {
            changedValues[key] = newValue;
          }
        }
      });

      // Remove keys with undefined values
      Object.keys(changedValues).forEach(key => {
        if (changedValues[key] === undefined) {
          delete changedValues[key];
        }
      });
    }



    const body = {
      object_name: objectName,
      data: {
        _id: selectedRecord?._id && !selectedRecord?.isClone ? selectedRecord._id : undefined, // If cloning, exclude the ID
        ...((selectedRecord?.isClone || !selectedRecord?._id) ? updatedValues : changedValues)
      }
    };


    try {
      setLoading(true);
      // Create an instance of ApiService for the POST request
      const apiService = new ApiService(
        `${BASE_URL}/insert_or_update_records`,
        { 'Content-Type': 'application/json' },
        'POST',
        body
      );

      const response = await apiService.makeCall();

      message.success(selectedRecord?._id && !selectedRecord?.isClone ? 'Record updated successfully' : 'Record created successfully');

      //fetchRecords('recentlyViewed',currentPage,pageSize);
      // form.resetFields();
      if (!saveAndNew) {
        if (creationView === "Modal") {
          setModalVisible(false);
        }
        else {
          setDrawerVisible(false);
        }
        form.resetFields();
        if (isCreateNewRecord) {
          navigate(`/record/${objectName}/${response._id}`, { state: { response, objectid: id } });
        }
        fetchRecords(selectedView, currentPage);
      } else {
        form.resetFields();
        const value = {
          _id: currUserId,
          Name: currUserName,
        }
        form.setFieldsValue({ User: value });
        fetchRecords(selectedView, currentPage);


      }



    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save record due to an unknown error';
      message.error(errorMessage);
    } finally {
      setLoading(false); // Ensure loading is stopped regardless of success or failure
    }
  };

  const handleFinishFailed = (errorInfo) => {
    const { errorFields } = errorInfo;
    errorFields.forEach((field) => {
      const fieldName = field.name.join('.'); // Handle nested field names
      message.error(`${fieldName} is required.`);
    });
  };

  const handleLabelClick = (record) => {
    if (security?.object_settings?.[objectName]?.object_setting.view === false) {
      message.error('You dont have permission to view ');
      return;
    }
    if (record._id) {
      navigate(`/record/${objectName}/${record._id}`, { state: { record, objectid: id } });
    } else {
      console.error("Record ID is undefined");
    }
  };

  const deleteRecord = async (record) => {
    if (security?.object_settings?.[objectName]?.object_setting.delete === false) {
      message.error('You dont have permission to delete ');
      return;
    }
    try {
      // Create ApiService instance for DELETE request
      const apiService = new ApiService(
        `${BASE_URL}/delete_record/${objectName}/${record._id}`,
        {}, // Headers (if any)
        'DELETE'
      );

      await apiService.makeCall();
      message.success('Record deleted successfully.');
      fetchRecords(selectedView, currentPage);
    } catch (error) {
      message.error('Failed to delete record.');
      console.error('Error deleting record:', error);
    }
  };

  const confirmDelete = async () => {
    deleteRecord(selectedRecord);

    setIsDeleteModalVisible(false);

  };

  if (error) {
    return <p>Error: {error}</p>;
  }

  const showCreateListDrawer = (listView) => {
    SetListViewInDrawer(listView); // Set the selected list view for editing
    setIsListViewDrawerVisible(true); // Show the drawer
    setIsListFromObjectPage(true);

  };

  const closeCreateListDrawer = () => {
    setIsListViewDrawerVisible(false); // Hide the drawer
  };

  const handleDeleteListView = async (selectedListView) => {


    if (selectedListView?.is_default || selectedListView?.is_system) {
      message.error("You cannot delete this view");
      return;
    }

    try {
      const apiService = new ApiService(
        `${BASE_URL}/delete_listview/${selectedListView._id}`,
        {},
        'DELETE'
      );
      const response = await apiService.makeCall();
      message.success('List View Deleted Successfully');
      fetchListViews();
      const viewid = listViews.filter(listview => listview.is_default === true);
      fetchRecords(viewid, currentPage);

    } catch (error) {
    }
  }

  const handleListViewMenuClick = ({ key }) => {
    if (key === 'create') {
      showCreateListDrawer();
    } else if (key === 'edit') {
      showCreateListDrawer(selectedListView);
    } else if (key === 'clone') {
      if (selectedListView) {
        // Clone the selected list view without the id and modify the name
        const clonedListView = {
          ...selectedListView, // clone the selected list view
          _id: undefined, // remove the id
          list_view_name: `Cloned by ${selectedListView?.list_view_name}`, // replace name with the cloned name
        };

        // Show the drawer with the cloned list view
        showCreateListDrawer(clonedListView);
      }
    }
    else if (key === 'delete') {
      Modal.confirm({
        title: 'Are you sure you want to delete this list view?',
        content: '',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => handleDeleteListView(selectedListView),
      });
    }
  };

  const listViewMenu = (
    <Menu onClick={handleListViewMenuClick}>
      <Menu.Item key="create" disabled={security?.system_settings?.list_view?.create === false}>Create</Menu.Item>
      <Menu.Item key="edit" disabled={!selectedListView || security?.system_settings?.list_view?.edit === false}>Edit</Menu.Item>
      <Menu.Item key="clone" disabled={!selectedListView || security?.system_settings?.list_view?.create === false}>Clone</Menu.Item>
      <Menu.Item key="delete" disabled={!selectedListView || security?.system_settings?.list_view?.delete === false}>Delete</Menu.Item>

    </Menu>
  );

  const handleFileUpload = () => {
    navigate(`/setup/import`);
  };

  const mapOperator = (operator) => {
    switch (operator) {
      case "$gt":
        return ">";
      case "$gte":
        return ">=";
      case "$lt":
        return "<";
      case "$lte":
        return "<=";
      case "$ne":
        return "!=";
      case "contains":
        return "Contains";
      case "starts_with":
        return "startsWith";
      case "ends_with":
        return "endsWith";
      default:
        return operator; // Fallback for unknown operators
    }
  };

  const handleSearch = () => {
    const filteredRecords = allRecords.filter((record) => {
      // Combine all relevant fields into a searchable string
      const searchableValues = [
        ...Object.values(record).map((value) =>
          typeof value === "object" && value !== null
            ? Object.values(value).join(" ") // Include nested object values
            : value?.toString()
        ),
      ].join(" ").toLowerCase();

      return searchableValues.includes(searchRecord.toLowerCase());
    });
    setRecords(filteredRecords);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearchChange = (e) => {

    const value = e.target.value;
    setSearchRecord(value);
    handleSearch();


    // Reset records if the input is cleared
    if (value.trim() === "") {
      setRecords(allRecords); // Replace with your original records
    }
  };

  const fetchCurrency = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_currencies`, {
        'Content-Type': 'application/json',
      }, 'GET');
      const response = await apiService.makeCall();
      setActiveCurrencies(response);
    } catch (err) {
      console.error("Error fetching metadata:", err);
    } finally {
      setLoading(false);
    }
  };

  const getConvertedValue = (amount, fromCode, toCode) => {
    const parsedAmount = parseFloat(amount);

    // Check for invalid or empty amount
    if (isNaN(parsedAmount) || fromCode === toCode) {
      return isNaN(parsedAmount) ? '0.00' : parsedAmount.toFixed(2);
    }
    const fromCurrency = activeCurrencies.find(c => c.iso_code === fromCode);
    const toCurrency = activeCurrencies.find(c => c.iso_code === toCode);
    if (!fromCurrency || !toCurrency || !fromCurrency.conversion_rate || !toCurrency.conversion_rate) {
      return '0.00';
    }

    const inCorporate = parsedAmount / fromCurrency.conversion_rate;
    const converted = inCorporate * toCurrency.conversion_rate;

    return converted.toFixed(2);
  };

  const handleExportClick = () => {
    if (security?.object_settings?.[objectName]?.object_setting.edit === false) {
      message.error('You dont have permission to export ');
      return;
    }
    setIsExportModalVisible(true);
  };

  const handleImportClick = () => {

    handleFileUpload();
  };

  const handlePinListView = async (view) => {
    if (!view) return;

    const previousListView = selectedListView; // store current one
    setSelectedListView(view); // optimistically update UI
    setSelectedView(view);

    try {
      setLoading(true);
      // If it’s already pinned, unpin it. Otherwise, make it default.
      const updatedValue = !view.is_default;
      setSelectedView({ ...view, is_default: updatedValue });

      // Call backend API to persist change
      const apiServiceEdit = new ApiService(
        `${BASE_URL}/edit_list_view/${selectedListView?._id}`,
        { 'Content-Type': 'application/json' },
        'PATCH',
        {
          mt_list_view: {
            is_default: updatedValue
          },
        }
      );
      await apiServiceEdit.makeCall();
      fetchListViews();


      message.success(updatedValue ? "Pinned as default view" : "Unpinned successfully");

    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save record due to an unknown error';
      message.error(errorMessage);
      // Revert UI change on error
      setSelectedListView(previousListView);
      setSelectedView(previousListView);

    } finally {
      setLoading(false);
      setSelectedListView(previousListView);
      setSelectedView(previousListView);
    }
  };

  return (
    <Spin spinning={loading} tip="Loading..." size="medium">

      <Card style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', padding: 2 }}>
        <Row style={{ margin: 0, padding: 0 }}>
          {/* Row 1 - Title */}
          <Col span={24} style={{ marginBottom: 8 }}>
            <Title level={4} style={{ margin: 0, fontSize: 18 }}>
              Records for {objectPluralName}
            </Title>
          </Col>

          {/* Row 2 - Actions */}
          <Col span={24}>
            <Row justify="space-between" align="middle" style={{ margin: 0, padding: 0 }}>
              {/* Left Side */}
              <Col style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <Select
                  value={selectedView?.list_view_name ? selectedView?.list_view_name : selectedView}
                  onChange={handleViewChange}
                  style={{ width: 160 }}
                  size="small"
                >
                  {listViews?.map(view => (
                    <Option key={view?._id} value={view?._id}>
                      {view.is_default && (
                        <PushpinFilled style={{ marginRight: 4 }}
                        />
                      )}
                      {view?.list_view_name}

                    </Option>
                  ))}
                </Select>

                {/* Pin/Unpin Button */}
                <Tooltip title={selectedView?.is_default ? "Unpin this view" : "Pin this view"}>
                  <Button
                    type="text"
                    icon={
                      selectedView?.is_default ? (
                        <PushpinFilled

                        />
                      ) : (
                        <PushpinOutlined

                        />
                      )
                    }
                    onClick={() => handlePinListView(selectedView)}
                  />
                </Tooltip>



                <Dropdown overlay={listViewMenu} trigger={["click"]}>
                  <Button size="small" style={{ border: "1px solid #d9d9d9", height: 28 }}>
                    <SettingOutlined />
                    <CaretDownOutlined style={{ marginLeft: 2 }} />
                  </Button>
                </Dropdown>

                {!showInput ? (
                  <Button
                    icon={<SearchOutlined />}
                    onClick={() => setShowInput(true)}
                    size="small"
                    style={{ border: "1px solid #d9d9d9", height: 28 }}
                  />
                ) : (
                  <Input
                    placeholder="Search in the list"
                    style={{ width: 140, height: 28 }}
                    value={searchRecord}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyPress}
                    onBlur={() => setShowInput(false)}
                    autoFocus
                    size="small"
                    prefix={<SearchOutlined />}
                    suffix={
                      <CloseOutlined
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSearchRecord("");
                          handleSearchChange("");
                          setShowInput(false);
                        }}
                      />
                    }
                  />
                )}
              </Col>

              {/* Right Side */}
              <Col style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <Tooltip
                  title={`Switch to ${tableView === "listView" ? "Grid View" : "List View"}`}
                >
                  <Switch
                    checkedChildren="Grid"
                    unCheckedChildren="List"
                    onChange={(checked) => {
                      const newView = checked ? 'gridView' : 'listView';
                      setTableView(newView);
                    }}
                    checked={tableView === "gridView"}
                    size="small"
                  />
                </Tooltip>

                {security?.system_settings?.export_records?.create === true && (
                  <Button
                    icon={<ExportOutlined />}
                    onClick={handleExportClick}
                    size="small"
                  >
                    Export
                  </Button>
                )}
                {security?.system_settings?.import_records?.create === true && (
                  <Button
                    icon={<ImportOutlined />}
                    onClick={handleImportClick}
                    size="small"
                  >
                    Import
                  </Button>
                )}
                <Button type="primary" onClick={handleCreateClick} size="small">
                  Create
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        <div style={{ flex: 1, overflow: 'auto', margin: 0, padding: 0, marginTop: 3,height:'71vh' }}>
          {(tableView === 'listView') &&

            <ListViewTable
              fieldsData={fieldsData}
              fetchCurrency={fetchCurrency}
              getConvertedValue={getConvertedValue}
              activeCurrencies={activeCurrencies}
              records={records}
              handleLabelClick={handleLabelClick}
              handleCloneClick={handleCloneClick}
              handleEditClick={handleEditClick}
              deleteRecord={deleteRecord}
              fetchRecords={fetchRecords}
              setPageSize={setPageSize}
              selectedListView={selectedView}
              currentPage={currentPage}
              pageSize={pageSize}
              totalRecords={totalRecords}
              objectName={objectName}
            >

            </ListViewTable>
          }
          {(tableView === 'gridView') &&
            <GridViewTable
              fieldsData={fieldsData}
              fetchCurrency={fetchCurrency}
              getConvertedValue={getConvertedValue}
              activeCurrencies={activeCurrencies}
              records={records}
              handleLabelClick={handleLabelClick}
              handleCloneClick={handleCloneClick}
              handleEditClick={handleEditClick}
              deleteRecord={deleteRecord}
              fetchRecords={fetchRecords}
              setPageSize={setPageSize}
              selectedListView={selectedView}
              currentPage={currentPage}
              pageSize={pageSize}
              totalRecords={totalRecords}
              objectName={objectName}
              setCurrentPage={setCurrentPage}
              setLoading={setLoading}
            >
            </GridViewTable>
          }
        </div>


        {(drawerVisible &&
          <CreateRecordDrawer
            objectName={objectName}
            visible={drawerVisible}
            onClose={() => setDrawerVisible(false)}
            onFinish={handleFinish}
            loading={loading}
            fieldsData={fieldsDataDrawer}
            selectedRecord={selectedRecord}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            form={form}
            handleFinishFailed={handleFinishFailed}
          />
        )}

        {(modalVisible &&
          <CreateRecordModal
            objectName={objectName}
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            onFinish={handleFinish}
            loading={loading}
            fieldsData={fieldsDataDrawer}
            selectedRecord={selectedRecord}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            form={form}
            handleFinishFailed={handleFinishFailed}
          // layout={layout}
          />
        )}

        {(isListViewDrawerVisible &&
          <CreateListViewDrawer
            visible={isListViewDrawerVisible}
            onClose={closeCreateListDrawer}
            object={objectForListView}
            fetchListViews={fetchListViews}
            selectedListView={ListViewInDrawer}
            isListViewFromObjectPage={isListViewFromObjectPage}
            currentPage={currentPage}
            fetchRecords={fetchRecords}
            setListView={setSelectedListView}
            setSelectedView={setSelectedView}

          />
        )}

        <Modal
          title="Confirm Deletion"
          visible={isDeleteModalVisible}
          zIndex={1002}   // higher than sidebar
          onOk={confirmDelete}
          onCancel={() => setIsDeleteModalVisible(false)}
          okText="Delete"
          cancelText="Cancel"
          centered
        >
          <p>Are you sure you want to delete this record?</p>
        </Modal>
        <ExportModal fieldsData={fieldsDataDrawer} isExportModalVisible={isExportModalVisible} setIsExportModalVisible={setIsExportModalVisible} objectPluralName={objectPluralName} objectName={objectName} record={allRecords[0]} />
      </Card>

    </Spin>


  );
};

export default ObjectSetupDetail;